"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIDDEN_RENDERING_NAME = exports.SITECORE_EDGE_URL_DEFAULT = exports.siteNameError = exports.JSS_MODE = exports.FETCH_WITH = exports.SitecoreTemplateId = void 0;
var SitecoreTemplateId;
(function (SitecoreTemplateId) {
    // /sitecore/templates/Foundation/JavaScript Services/App
    SitecoreTemplateId["JssApp"] = "061cba1554744b918a0617903b102b82";
    // /sitecore/templates/System/Dictionary/Dictionary entry
    SitecoreTemplateId["DictionaryEntry"] = "6d1cd89719364a3aa511289a94c2a7b1";
})(SitecoreTemplateId || (exports.SitecoreTemplateId = SitecoreTemplateId = {}));
exports.FETCH_WITH = {
    GRAPHQL: 'GraphQL',
    REST: 'REST',
};
exports.JSS_MODE = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
};
exports.siteNameError = 'The siteName cannot be empty';
exports.SITECORE_EDGE_URL_DEFAULT = 'https://edge-platform.sitecorecloud.io';
exports.HIDDEN_RENDERING_NAME = 'Hidden Rendering';
